import features from 'common/college-features'
import permissions from 'common/system-permissions'
import useCollegeFeatures from 'common/use-college-features'
import useIsShadow from 'common/use-is-shadow'
import usePermissions from 'common/use-permissions'

export const useCanViewReadOnly = () => {
  const isApplicationIntegrationEnabled = useCollegeFeatures(features.APPLICATION_INTEGRATION)
  const hasApplicationManagerPermission = usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
  return (isApplicationIntegrationEnabled && !hasApplicationManagerPermission) || !isApplicationIntegrationEnabled
}

export const useIsApplicationIntegrationEnabled = () => {
  return useCollegeFeatures(features.APPLICATION_INTEGRATION)
}

export default () => {
  const isShadow = useIsShadow()
  const isApplicationIntegrationEnabled = useCollegeFeatures(features.APPLICATION_INTEGRATION)
  const hasApplicationManagerPermission = usePermissions(permissions.MANAGE_COLLEGE_APPLICATION_ROUNDS)
  return (isApplicationIntegrationEnabled && hasApplicationManagerPermission) || isShadow
}
